import { allowedUsers, keysToRemove } from "../../constants/constants";
import {
  getPermissionsForEC,
  getPermissionsForEU,
} from "../../redux/slices/Permissions";
import {
  setBranchLogo,
  setUserInformation,
} from "../../redux/slices/UserSlice";
import { checkInDepthRoutes, fetchTranslations } from "../../utils/Utilities";
import { getVdsProfile } from "../user/UserServices";
import i18next from "i18next";
import {
  BASE_URL,
  COMMON,
  uUrls,
  VDS_KEY,
  VERSION,
} from "../../constants/ApiUrls";
import axios from "axios";

export const getUser = async (dispatch) => {
  keysToRemove.forEach((item) => {
    localStorage.removeItem(item);
  });

  const getBranchImage = (imageURL) => {
    const url = `${BASE_URL}${VDS_KEY}${VERSION}${uUrls.BRANCH_LOGO}/file?mediaPath=${imageURL}`;
    axios.get(url, { responseType: "blob" }).then((response) => {
      dispatch(setBranchLogo(response.data));
    });
  };

  let result = await getVdsProfile();
  if (result?.success) {
    if (result?.payLoad?.uploadedFiles?.logo) {
      getBranchImage(result?.payLoad?.uploadedFiles?.logo?.url);
    }
    dispatch(setUserInformation(result?.payLoad));
    localStorage.setItem(
      "branchInfo",
      JSON.stringify(result?.payLoad?.branchInfo)
    );
    localStorage.setItem("role", result?.payLoad?.role?.roleName);
    localStorage.setItem("loggedInUserId", result?.payLoad?.id);
    localStorage.setItem("currentConsultantId", result?.payLoad?.consultantId);
    localStorage.setItem(
      "userName",
      result?.payLoad?.firstName + " " + result?.payLoad?.lastName
    );
    localStorage.setItem("firstName", result?.payLoad?.firstName);
    localStorage.setItem("lastName", result?.payLoad?.lastName);
    localStorage.setItem("userGender", result?.payLoad?.gender);
    localStorage.setItem(
      "LanguagePreference",
      JSON.stringify(result?.payLoad?.languagePreference)
    );
    localStorage.setItem("auth", true);
    localStorage.setItem(
      "uploadedFiles",
      result?.payLoad?.uploadedFiles
        ? JSON.stringify(result?.payLoad?.uploadedFiles)
        : result?.payLoad?.uploadedFiles
    );

    if (
      result?.payLoad?.languagePreference &&
      result?.payLoad?.languagePreference !== i18next.language
    ) {
      i18next.changeLanguage(result?.payLoad?.languagePreference);
    }

    localStorage.setItem("products", JSON.stringify(result?.payLoad?.products));
    if (
      allowedUsers.findIndex(
        (item) => item === result?.payLoad?.role?.roleName
      ) !== -1 &&
      result.payLoad.permissions?.menuStructures?.filter(
        (item) => item?.applicationKey === "#FutureCare"
      )?.length > 0
    ) {
      if (
        (result?.payLoad?.futureCareProfileStatus &&
          result?.payLoad?.futureCarePermissions &&
          result?.payLoad?.futureCareTermsOfUse &&
          result?.payLoad?.role?.roleName === "#EU" &&
          (JSON.parse(localStorage.getItem("phoneNumberConfirmed")) ||
            result?.payLoad?.phoneNumberConfirmed)) ||
        (result?.payLoad?.futureCareProfileStatus &&
          result?.payLoad?.role?.roleName !== "#EU")
      ) {
        const arr = [];
        result.payLoad.permissions?.menuStructures.forEach((item) => {
          if (item.applicationKey === "#FutureCare") {
            if (item.parentId === null) {
              arr.push({ ...item });
            } else {
              arr.forEach((parentObj) => {
                checkInDepthRoutes(parentObj, item);
              });
            }
          }
        });
        if (arr.length > 0) {
          localStorage.setItem("menuStructure", JSON.stringify(arr));
          localStorage.setItem(
            "userPermissions",
            JSON.stringify(result?.payLoad?.permissions?.claims)
          );
          const event = new CustomEvent("localdatachanged");
          document.dispatchEvent(event);
          localStorage.setItem("auth", true);
          if (
            result.payLoad?.role?.roleName?.toLowerCase() ===
            allowedUsers[0].toLowerCase()
          ) {
            dispatch(getPermissionsForEU(result.payLoad.permissions?.claims));
          } else if (
            result.payLoad?.role?.roleName?.toLowerCase() ===
            allowedUsers[1].toLowerCase()
          ) {
            dispatch(getPermissionsForEC(result.payLoad.permissions?.claims));
          }
        } else {
          localStorage.setItem("auth", true);
          return {
            route: "/not-allowed",
            state: {},
          };
          // navigate("/not-allowed");
        }
      } else {
        return {
          route: "/portfolio",
          state: { key: result?.payLoad },
        };
        // navigate("/portfolio", {
        //   state: { key: result?.payLoad },
        // });
      }
      return {
        route: null,
        state: null,
        consultantEnabled: result?.payLoad?.consultantId == null ? false : true,
        role: result?.payLoad?.role?.roleName,
      };
    } else {
      localStorage.setItem("auth", true);
      return {
        route: "/not-allowed",
        state: {},
      };
      //   navigate("/not-allowed");
    }
  } else {
    // navigate("/login");
    return {
      route: "/login",
      state: {},
    };
  }
};
